export function parseDecimalInput(value: string | number | null | undefined): number | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined;

  const normalized = value.trim();
  if (normalized === "") return undefined;

  let sanitized = normalized;

  if (normalized.includes(",") && normalized.includes(".")) {
    const usThousandsPattern = /^[+-]?\d{1,3}(,\d{3})+(\.\d+)?$/;
    if (!usThousandsPattern.test(normalized)) return undefined;
    sanitized = normalized.replace(/,/g, "");
  } else if (normalized.includes(",")) {
    const commaThousandsPattern = /^[+-]?\d{1,3}(,\d{3})+$/;
    if (commaThousandsPattern.test(normalized)) {
      sanitized = normalized.replace(/,/g, "");
    } else {
      sanitized = normalized.replace(",", ".");
    }
  }

  const parsed = Number(sanitized);
  return Number.isFinite(parsed) ? parsed : undefined;
}
